import React from 'react';

export const RichTextInputAreaContext = React.createContext();
